class Video extends HTMLElement {
	constructor() {
		super()

		this.selectors = {
			play: '[data-behavior="play-video"]',
			pause: '[data-behavior="pause-video"]',
			externalContainer: '.js-video-container'
		}

		this.classes = {
			hide: "hide",
		}

		this.container = this.closest(this.selectors.externalContainer) || this
		this.image = this.container.querySelector("picture")
		this.video = this.container.querySelector("video")
		this.playBtn = this.container.querySelector(this.selectors.play)
		this.pauseBtn = this.container.querySelector(this.selectors.pause)
		this.autoPlay = this.video.hasAttribute("data-autoplay") || (this.video.hasAttribute('autoplay') && this.video.getAttribute('autoplay') == 'autoplay')
		this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
	}

	connectedCallback() {
		// Do not 'autoplay' videos if not enabled, or if user has reduced motion preference selected
		this.autoPlay && !this.reducedMotion ? this._autoplayVideo() : this._switchButton("play", false)

		// Handle video play and pause clicks
		this.container.addEventListener("click", this._handleVideoClick.bind(this))
	}

	/*
		Event Listener Callback
	*/

	_handleVideoClick(e) {
		const target = e.target

		if (target == this.playBtn) {
			this._pauseAllOtherVideos()
			this._playVideo()
		}

		if (target == this.pauseBtn) {
			this._pauseVideo()
		}
	}

	/*
		Play, Pause, and Button Functionality
	*/

	_playVideo() {
		this.video.play()
		this._switchButton("pause")
		if (this.image) this.image.classList.add(this.classes.hide)
	}

	_pauseVideo() {
		this.video.pause()
		this._switchButton("play")
	}

	_switchButton(type, focusButton = true, playBtn = this.playBtn, pauseBtn = this.pauseBtn) {
		if (type == "play") {
			playBtn.classList.remove(this.classes.hide)
			pauseBtn.classList.add(this.classes.hide)
			if (focusButton) this.playBtn.focus()
		}

		if (type == "pause") {
			playBtn.classList.add(this.classes.hide)
			pauseBtn.classList.remove(this.classes.hide)
			if (focusButton) this.pauseBtn.focus()
		}
	}

	_pauseAllOtherVideos() {
		const allVideoContainers = [...document.querySelectorAll("html-video")]

		for (const container of allVideoContainers) {
			const video = container.querySelector("video")

			if (video != this.video) {
				const playBtn = container.querySelector(this.selectors.play)
				const pauseBtn = container.querySelector(this.selectors.pause)

				video.pause()
				this._switchButton("play", false, playBtn, pauseBtn)
			}
		}
	}

	_autoplayVideo() {
		// Video is ready when we have enough data to play at least
		// one frame
		const videoReady = this.video.readyState >= 2

		// Make sure that video is muted if autoplaying
		// This is to meet accessibility standards for
		// autoplaying videos
		this.video.muted = true

		// Only run function if the video is fully loaded
		if (videoReady) {
			// Rather than adding 'autoplay' attribute to <video> elements, wait until section loads to play
			// Note: using video playback promise https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
			let playPromise = this.video.play()

			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						if (this.image) this.image.classList.add(this.classes.hide)
						this._switchButton("pause", false)
					})
					.catch(error => {
						console.error(error)
					})
			}
		}

		if (!videoReady) {
			// Video isn't loaded yet, so wait until it's ready
			this.video.addEventListener("loadeddata", this._autoplayVideo.bind(this))
		}
	}
}

customElements.define('html-video', Video);

/**
 * For modal video (larger video, external source)
 * stop teaser video when modal is open
 * stop video when modal is closed
 * 
 * Not the ideal method, but works for both YouTube and Vimeo
 */

function isVideoPlaying(videoElement) {
	return !videoElement.paused && !videoElement.ended && videoElement.currentTime > 0;
}

window.addEventListener("openVideoModal", function(e) { 
    const videoEl = document.querySelector(`#${e.detail.videoId}`); 

	if (videoEl) { 
		const sectionId = videoEl.closest(".modal").getAttribute("data-section-id"); 

		if (sectionId) { 
			const videoSection = document.querySelector(`.video-cta-text[data-section-id="${sectionId}"]`); 

			if (videoSection) { 
				const teaserVideo = videoSection.querySelector(".js-teaser-video"); 

				if (teaserVideo && isVideoPlaying(teaserVideo)) { 
					// Programmatically "click" play/pause button so button state is correct (rather than teaserVideo.pause())
					if (teaserVideo.closest(".js-video-container").querySelector('[data-behavior="pause-video"]')) { 
						teaserVideo.closest(".js-video-container").querySelector('[data-behavior="pause-video"]').click(); 
					}
				}
			}
		}
	}
}); 


window.addEventListener("closeVideoModal", function(e) { 
    const videoSrc = document.querySelector(`#${e.detail.videoId}`).getAttribute("src"); 

    document.querySelector(`#${e.detail.videoId}`).setAttribute("src", ""); 
    document.querySelector(`#${e.detail.videoId}`).setAttribute("src", videoSrc); 
}); 
